var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-group"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"avatar"},[_c('span',{staticClass:"avatar-name"},[_vm._v(_vm._s(item.name))]),_c('img',{attrs:{"src":item.photo ? `${_vm.apiUrl}/images/user/${item.photo}` : `/avatar.png`,"alt":"Image"}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }